import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';

const useRtmpAccess = (): boolean => {
  const { subscriptionDetails } = useCustomer();
  const count = subscriptionDetails?.concurrentRtmpStreams ?? 0;
  return count > 0;
};

export default useRtmpAccess;
